import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../service/translation';

export default class ExtendedFilterToggle extends Component {

    static propTypes = {
        onClick: PropTypes.func,
        extendedSearch: PropTypes.boolean,
        EXTKEY: PropTypes.string
    };

    render() {
        const {onClick, extendedSearch, EXTKEY} = this.props;

        return (
            <a onClick={onClick} className={EXTKEY + '__link ' + EXTKEY + '__link--toggle-filter ' + EXTKEY + '__toggle-filter-' + (extendedSearch ? 'extendedState' : 'simpleState') + ' extendedFilterToggle'}>
                <span className={EXTKEY + '__link--text ' + EXTKEY + '__toggle-filter--text filterToggleText ' + (extendedSearch ? 'extendedState' : 'simpleState')}>
                    {extendedSearch ?
                        translate('list_filter_simple_toggle') :
                        translate('list_filter_extended_toggle')
                    }
                </span>
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/ExtendedFilterToggle.js